import { useState } from "react";
import { FC, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Icon from "./general/Icon";

const ScrollToTop: FC = () => {

  const { pathname } = useLocation();
  const [showButton, setShowButton] = useState<boolean>(false);

  const scrollWindow = () => {
    const scroll = window.scrollY;

    if (scroll > 170)
      setShowButton(true)
    else
      setShowButton(false)
  }

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);

  useEffect(() => {
    document.addEventListener("scroll", scrollWindow);
    return () => document.removeEventListener("scroll", scrollWindow);
  }, []);

  const onButtonClick = () => {
    setShowButton(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  return (
    <div className={`scroll-to-top${showButton ? " show-button" : ""}`}>
      <Icon name="icon-backward" color="primary" onClick={onButtonClick} />
    </div>
  )
}

export default ScrollToTop;